import {
  YourDetails,
  TreatmentListDetails,
} from '../routes/review';

import { PATH_NAMES } from '../constants';

import {
  TotalPriceDetails,
} from '../components/total-price-details';
import { envConfigSelectors } from '~/selectors';
import { EditDateTime } from '~/routes';
import { withComponentDecisioner } from '~/hocs/with-component-decisioner';
import { EditDate } from '~/routes/edit';

const componentDecisioner = [
  {
    supports: envConfigSelectors.selectIsNewCalendarEnabled,
    component: EditDateTime,
  },
];

export const config = {
  editMode: {
    firstEditPagePath: PATH_NAMES.EDIT_DATE,
    hideEditDateTitle: true,
    hideGoBackButton: true,
    editDateComponent: withComponentDecisioner(() => componentDecisioner)(EditDate),
  },
  ReviewIntro: {
    title: 'Review',
    buildDescription: shop => `Please review your details before you complete your appointment booking with ${shop}.`,
  },
  ReviewYourDetails: {
    displayFullName: true,
    isDisplayQuestions: (questions, answers) => (
      questions
        .map(question => question.reduxFieldConfig.name)
        .some(id => answers[id] && answers[id].some(answer => !!answer))
    ),
  },
  ReviewForm: {
    hideEditButton: true,
    MainDetails: () => null,
    YourDetails,
    TotalPriceDetailsComponent: TotalPriceDetails,
    TreatmentListDetails,
  },
};
